import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { FsSidenavModule, SidenavMenuRef } from '@firestitch/sidenav';

import { tap } from 'rxjs';

import { SessionService } from '@app/core';
import { AccountData } from '@common/data';


import { SidenavService } from '../../services';

@Component({
  selector: 'app-organization-experience-menu',
  standalone: true,
  imports: [
    FsSidenavModule,
  ],
  templateUrl: './organization-experience-menu.component.html',
  styleUrl: './organization-experience-menu.component.scss',
})
export class OrganizationExperienceMenuComponent {
  sidenavService = inject(SidenavService);
  router = inject(Router);
  accountData = inject(AccountData);
  menuRef = inject<SidenavMenuRef<OrganizationExperienceMenuComponent>>(SidenavMenuRef);
  private _sessionService = inject(SessionService);


  public switchParent(): void {
    this.accountData.experienceSwitch('parent')
      .pipe(
        tap(() => {
          this._sessionService.switchEnvironment();
        }),
      )
      .subscribe(() => {
        this.menuRef.close();
        this.router.navigateByUrl('/parent');
      });
  }

}
